var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "job-content-table",
        { attrs: { title: "企業情報" } },
        [
          _c("job-content-table-outline", {
            attrs: {
              title: "業種",
              value: _vm.companySupplementInfo.businessName,
            },
          }),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            {
              attrs: {
                title: "正式社名",
                value: _vm.companySupplementInfo.formalName,
              },
            },
            [
              _c("br"),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "pega-company-preview-name-caution-text" },
                [
                  _vm._v(
                    "\n        ※支店名、事業部名、グループ名等の入力不可。\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.companySupplementInfo.isVisibleInGoogle
                ? _c(
                    "span",
                    {
                      staticClass: "pega-company-preview-name-caution-text",
                      attrs: { "data-test": "formal-company-name-cation" },
                    },
                    [
                      _vm._v(
                        "\n        ※提携サイト掲載時にこちらの社名が使用されます。\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            {
              attrs: {
                title: "表示用社名",
                value: _vm.companySupplementInfo.name,
              },
            },
            [
              !_vm.companySupplementInfo.isVisibleInGoogle
                ? [
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "pega-company-preview-name-caution-text",
                        attrs: { "data-test": "company-name-cation" },
                      },
                      [
                        _vm._v(
                          "\n          ※提携サイト掲載時にこちらの社名が使用されます。\n        "
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("job-content-table-outline", {
            attrs: {
              title: "表示用社名(カナ)",
              value: _vm.companySupplementInfo.nameKana,
            },
          }),
          _vm._v(" "),
          _c("job-content-table-outline-sub", {
            attrs: { title: "関連キーワード", contents: _vm.keywords },
          }),
          _vm._v(" "),
          _c("job-content-table-outline-sub", {
            attrs: { title: "関連リンク", contents: _vm.relationLinks },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "応募フォーム" } },
        _vm._l(_vm.questions, function (question, i) {
          return _c("job-content-table-outline", {
            key: i,
            attrs: {
              title: "独自質問項目名[" + (i + 1) + "]",
              value: question,
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }